import { json, redirect } from "@remix-run/node";
import { useLoaderData } from "@remix-run/react";
import { PersonalInfoForm } from "~/components/PersonalInfoForm";
import { personalInfoValidator } from "~/validators";
import { getSession, sessionStorage } from "~/services/session.server";
import { NEXT_STEP_KEY, PERSONAL_INFO_KEY, STEPS } from "~/constants";
import type { ActionFunctionArgs, LoaderFunctionArgs } from "@remix-run/node";

export async function action({ request }: ActionFunctionArgs) {
  const form = await request.formData();
  const { data, error } = await personalInfoValidator.validate(form);
  const session = await getSession(request);
  const headers = new Headers();
  const { pathname, searchParams } = new URL(request.url);
  const currentStep = STEPS.findIndex((item) => item.href === pathname);
  const nextStep = STEPS[(currentStep + 1) % STEPS.length];

  if (error) {
    return json({ error }, { status: 422 });
  }
  session.set(PERSONAL_INFO_KEY, data);
  session.set(NEXT_STEP_KEY, nextStep.id);
  headers.append("Set-Cookie", await sessionStorage.commitSession(session));
  return redirect(`${nextStep.href}?${searchParams}`, {
    headers,
  });
}

export async function loader({ request }: LoaderFunctionArgs) {
  const session = await getSession(request);
  const personalInfo = session.get(PERSONAL_INFO_KEY);

  return json({ personalInfo });
}

export default function PersonalInformationRoute() {
  const { personalInfo } = useLoaderData<typeof loader>();

  return <PersonalInfoForm personalInfo={personalInfo} />;
}
